import React from "react";
import { useLang } from "../i18n";

export default function LevelPath({ levels = [], currentPoints = 0 }) {
  const { pick } = useLang();
  const sorted = [...levels].sort((a, b) => a.min_points - b.min_points);
  const currentIdx = sorted.reduce((acc, lv, i) => (currentPoints >= lv.min_points ? i : acc), 0);
  return (
    <div dir="ltr" className="relative px-1 sm:px-4 py-3" data-testid="level-path">
      <div className="absolute top-[44%] left-8 right-8 border-t-[3px] border-dashed border-[#9C42F5]/35" aria-hidden="true" />
      <div className="relative flex items-start justify-between gap-1">
        {sorted.map((lv, i) => {
          const state = i < currentIdx ? "done" : i === currentIdx ? "current" : "future";
          return (
            <div key={lv.key || lv.id} data-testid={`level-stage-${lv.key}`} className="flex flex-col items-center gap-2 w-16 sm:w-24">
              <div className={`relative rounded-full transition-all duration-500 ${
                state === "current" ? "scale-110 animate-pulse-glow ring-4" :
                state === "done" ? "ring-2" : "opacity-40 saturate-50 ring-1 ring-white/15"}`}
                style={state !== "future" ? { ringColor: lv.color, boxShadow: `0 0 ${state === "current" ? 26 : 14}px ${lv.color}66` } : {}}>
                <img src={lv.icon} alt={pick(lv, "name")} loading="lazy"
                  className="w-14 h-14 sm:w-20 sm:h-20 rounded-full object-cover" />
                {state === "done" && (
                  <span className="absolute -bottom-1 -right-1 w-6 h-6 rounded-full bg-[#48D276] text-white text-xs font-black flex items-center justify-center glow-green">✓</span>
                )}
              </div>
              <span className={`text-[11px] sm:text-sm font-extrabold px-2.5 py-0.5 rounded-full border transition-colors ${
                state === "current" ? "text-white" : state === "done" ? "text-[#D8D4F2]" : "text-[#A5A0D6]/70"}`}
                style={{ borderColor: `${lv.color}${state === "future" ? "44" : "AA"}`, backgroundColor: `${lv.color}1F` }}>
                {pick(lv, "name")}
              </span>
              <span className="text-[10px] text-[#A5A0D6] font-bold">{lv.min_points}+</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
